<template>
  <div class="responsive-actions">
    <span v-if="!visibleItems.length">--</span>

    <template v-else>
      <div class="desktop-action-list">
      <el-button
        v-for="item in visibleItems"
        :key="item.key"
        :type="item.type || 'primary'"
        :plain="item.plain !== false"
        :disabled="Boolean(item.disabled)"
        size="mini"
        @click="select(item.key)"
      >
        {{ item.label }}
      </el-button>
      </div>

      <el-dropdown
        class="mobile-action-dropdown"
        trigger="click"
        placement="bottom-end"
        :hide-on-click="true"
        @command="select"
      >
        <el-button
          class="mobile-action-trigger"
          type="primary"
          plain
          aria-label="更多操作"
          title="更多操作"
        >
          <i class="el-icon-more"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" class="mobile-action-menu">
          <el-dropdown-item
            v-for="item in visibleItems"
            :key="item.key"
            :command="item.key"
            :disabled="Boolean(item.disabled)"
            :class="{ 'is-danger': item.type === 'danger' }"
          >
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </div>
</template>

<script>
export default {
  name: "ResponsiveActions",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    visibleItems() {
      return this.items.filter((item) => item && item.hidden !== true);
    },
  },
  methods: {
    select(key) {
      const item = this.visibleItems.find((current) => current.key === key);
      if (!item || item.disabled) {
        return;
      }
      this.$emit("select", key);
    },
  },
};
</script>

<style lang="less" scoped>
.responsive-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.desktop-action-list {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.mobile-action-dropdown {
  display: none;
}

.mobile-action-trigger {
  width: 44px;
  min-height: 44px;
  padding: 0;

  i {
    font-size: 18px;
  }
}

@media (max-width: 767px) {
  .desktop-action-list {
    display: none;
  }

  .mobile-action-dropdown {
    display: inline-flex;
  }
}
</style>
